import React from 'react';
import Loading from '../components/share/Loading';

const LoadingContext = React.createContext({
  isLoading: false,
  message: '',
});

class LoadingProvider extends React.Component {
  state = {
    isLoading: false,
    message: '',
  }

  showLoading = (message) => this.setState({
    isLoading: true,
    message: message
  })

  hideLoading = () => this.setState({ isLoading: false })

  render () {
    return (
      <LoadingContext.Provider
        value={{
          isLoading: this.state.isLoading,
          message: this.state.message,
          showLoading: this.showLoading,
          hideLoading: this.hideLoading
        }}
      >
        <LoadingConsumer>
          {({ isLoading, message, hideLoading }) => {
            if (isLoading) {
              return (
                <Loading
                  loading={isLoading}
                  message={message}
                  hideLoading={hideLoading}
                />
              );
            } else {
              return null;
            }
          }}
        </LoadingConsumer>
        {this.props.children}
      </LoadingContext.Provider>
    );
  }
}

const LoadingConsumer = LoadingContext.Consumer;

function withLoading (Component) {
  return function ComponentWithLoadingProps (props) {
    return (
      <LoadingConsumer>
        {({ showLoading, hideLoading }) =>
          <Component {...props} showLoading={showLoading} hideLoading={hideLoading} />
        }
      </LoadingConsumer>
    );
  };
}

export { LoadingProvider, LoadingConsumer, withLoading };
